import React, { FC } from "react";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AngleDown: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faAngleDown} {...props} />
);
